import axios from "../../../../axios";
import React, { useState } from "react";
import "./editDelete.css";

const EditReply = ({
  setReply,
  reply,
  setClickEditReply,
  setEdited,
  attachment,
  queryId,
  setAttachments,
  setAttachments1,
  attachmentCopy,
  getReplyReload
}) => {
  const [updateReply, setUpdateReply] = useState(reply.reply);

  // let attachment = reply.attachments;
  console.log("attachment", attachment)
  const Student_Id = JSON.parse(localStorage.getItem("breathForStudent"));
  const user_id = Student_Id?.id;

  // const getReply = async () => {
  //   await axios.get(`/query/reply/get/${queryId}?sortBy=-1`).then((response) => {
  //     // (searchClick)&&setReply([]);
  //     setReply([]);
  //     response.data.data.length > 0 && setReply(response.data.data);
  //   });
  // };
  const handleClick = async () => {
    if (updateReply.trim() !== '' || attachment.length > 0) {
      try {
        let res = await axios.put(`/query/reply/update/${reply.id}`, {
          user_id: user_id,
          reply: updateReply,
          attachments: attachment,
        });
        // res && setEdited(true)
        getReplyReload();
        if (res) {
          setAttachments([]);
        }
        setAttachments1((prev) => [...prev, ...attachment]);
        setClickEditReply(false);
        setReply([])
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <>
      <div className="my-2 gap-3 d-flex align-items-center">
        <textarea
          type="text"
          value={updateReply}
          onChange={(e) => setUpdateReply(e.target.value)}
          className="edit_interface"
        />
        <div className="yes_no gap-4 d-flex">
          <div className="done_discard" onClick={handleClick}>
            <img src="/images/done.svg" alt="" />
            <span>&nbsp; Done</span>
          </div>

          <div
            className="done_discard"
            onClick={(e) => {
              setClickEditReply(false)
              setAttachments1(attachmentCopy);
            }
            }
          >
            <img src="/images/discard.svg" alt="" />
            <span>&nbsp; Discard</span>
          </div>
        </div>
      </div>
    </>
  );
};
export default EditReply;
